import Model from 'flarum/Model';
import mixin from 'flarum/utils/mixin';

export default class HeroTagHeroIntro extends mixin(Model, {
  latestDataId: Model.attribute('latestDataId'),
  skillName: Model.attribute('skillName'),
  skillImg: Model.attribute('skillImg'),
  skillEffect: Model.attribute('skillEffect'),
  skillType: Model.attribute('skillType'),
  skillIntro: Model.attribute('skillIntro'),
  sort: Model.attribute('sort'),
  heroTagHeroLevel: Model.hasMany('heroTagHeroLevel'),

}) {
  apiEndpoint() {
    return '/heroTagHeroIntro' + (this.exists ? '/' + this.data.id : '');
  }
}
